import { Button, Typography, Grid } from '@mui/material';
import StyledModal from '../StyledModal';
import GreenBorderBox from '../../common/GreenBorderBox';
import colors from '../../../assets/colors';

export default function EditInfoParametersPlants(props) {
  const handleClose = () => props.setOpen(false);
  const handleSave = () => {
    props.editParameter();
    props.setOpen(false);
  };

  return (
    <>
      <StyledModal open={props.open} handleClose={handleClose}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ mb: 2 }}
        >
          <Typography sx={{ fontSize: 36, fontWeight: 500 }}>
            Edytowane wskaźniki
          </Typography>
        </Grid>
        <GreenBorderBox>
          <Grid container justifyContent="left">
            <Typography sx={{ fontSize: 16, color: colors.agroweGreen }}>
              Edytujesz wskaźnik:
            </Typography>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="space-around"
            columnSpacing={10}
            sx={{ mt: 3 }}
          >
            <Grid container item xs={2} direction="column" rowSpacing={1}>
              <Grid item>
                <Typography sx={{ fontSize: 16, color: colors.agroweGreen }}>
                  Nazwa uprawy
                </Typography>
              </Grid>
              <Grid item>
                {props.selectionData[props.currentlySelected].cropName}
              </Grid>
            </Grid>
            <Grid container item xs={2} direction="column" rowSpacing={1}>
              <Grid item>
                <Typography sx={{ fontSize: 16, color: colors.agroweGreen }}>
                  Zakresy
                </Typography>
              </Grid>
              <Grid item>{`${
                props.selectionData[props.currentlySelected]?.indexList[0]
                  ?.minArea
              }
                  -
                  ${
                    props.selectionData[props.currentlySelected]?.indexList[0]
                      ?.maxArea
                  }
                  ha`}</Grid>
              <Grid item>{`${
                props.selectionData[props.currentlySelected]?.indexList[1]
                  ?.minArea
              }
                  -
                  ${
                    props.selectionData[props.currentlySelected]?.indexList[1]
                      ?.maxArea
                  }
                  ha`}</Grid>
              <Grid item>{`${
                props.selectionData[props.currentlySelected]?.indexList[2]
                  ?.minArea
              }${
                props.selectionData[props.currentlySelected]?.indexList[2]
                  ?.maxArea > 100
                  ? '+'
                  : ' ' +
                    props.selectionData[props.currentlySelected]?.indexList[2]
                      ?.maxArea
              } ha`}</Grid>
            </Grid>
            <Grid container item xs={2} direction="column" rowSpacing={1}>
              <Grid item>
                <Typography sx={{ fontSize: 16, color: colors.agroweGreen }}>
                  Poprzednia wartość wskaźnika
                </Typography>
              </Grid>
              <Grid item>
                {
                  props.selectionData[props.currentlySelected].indexList[0]
                    ?.incomeValue
                }{' '}
                PLN
              </Grid>
              <Grid item>
                {
                  props.selectionData[props.currentlySelected].indexList[1]
                    ?.incomeValue
                }{' '}
                PLN
              </Grid>
              <Grid item>
                {
                  props.selectionData[props.currentlySelected].indexList[2]
                    ?.incomeValue
                }{' '}
                PLN
              </Grid>
            </Grid>
            <Grid container item xs={2} direction="column" rowSpacing={1}>
              <Grid item>
                <Typography sx={{ fontSize: 16, color: colors.agroweGreen }}>
                  Zmieniona wartość wskaźnika
                </Typography>
              </Grid>
              <Grid item>{props.newValues.value1} PLN</Grid>
              <Grid item>{props.newValues.value2} PLN</Grid>
              <Grid item>{props.newValues.value3} PLN</Grid>
            </Grid>
            <Grid container item xs={2} direction="column" rowSpacing={1}>
              <Grid item>
                <Typography sx={{ fontSize: 16, color: colors.agroweGreen }}>
                  Data od której obowiązuje
                </Typography>
              </Grid>
              <Grid item>
                {props.selectionData[props.currentlySelected].data}
              </Grid>
            </Grid>
          </Grid>
        </GreenBorderBox>
        <Grid container justifyContent="space-between" sx={{ mt: 2 }}>
          <Grid item>
            <Button variant="outlined" onClick={handleClose}>
              ANULUJ ZMIANY
            </Button>
          </Grid>
          <Grid item>
            <Button variant="outlined" onClick={handleSave}>
              ZAPISZ ZMIANY
            </Button>
          </Grid>
        </Grid>
      </StyledModal>
    </>
  );
}
